/* content file: replace all html between <> </> with actual content */

export const Impressum = () => { 
  return (
  <>
    <p>
      Gesamtverantwortung:<br/>
      Stadt Frankfurt am Main <br/>
      DER MAGISTRAT <br/>
      Römerberg 23 <br/>
      60311 Frankfurt am Main <br/>
      Website: www.frankfurt.de <br/>
      <br/>

      USt-ID: DE 114 110 388 <br/>
      <br/>
      Verantwortung für diese Microsite: <br/>
      Stadt Frankfurt am Main <br/>
      Der Magistrat <br/>
      <br/>
      Gesundheitsamt Frankfurt am Main <br/>
      Abteilung Digitale Zukunft, IT und strategische Planung <br/>
      Breite Gasse 28 <br/>
      60313 Frankfurt am Main <br/>
      Microsite: GA-Lotse.de <br/>

      GA-Lotse ist ein Kooperationsprojekt des <br/>
      Hessischen Ministeriums für Familie, Senioren, Sport, Gesundheit und Pflege <br/>
      mit dem Gesundheitsamt Frankfurt unter der EU-Förderung NextGeneration. <br/>
      <br/>
      Telefonische Auskünfte <br/>
      Informationen erhalten Sie über die Rufnummer:  +49 (0) 800 - 4256873<br/>
      <br/>
      Kontakt bei Presseanfragen: <br/>
      gesundheitsamt_einheitliche-software@stadt-frankfurt.de<br/>
      <br/>
      Kontakt bei Fragen zur Microsite: <br/>
      eMail: ga-lotse.gesundheitsamt@stadt-frankfurt.de <br/>
      Die Abteilung Digitale Zukunft, IT und strategische Planung des Gesundheitsamtes der Stadt Frankfurt am Main zeichnet für ihre Inhalte auf www.ga-lotse.de redaktionell verantwortlich.<br/>
      <br/>
      Verantwortung:<br/>
      Stefanie Kaulich, Abteilungsleitung Digitale Zukunft, IT und strategische Planung.<br/>
      Bei Fragen oder Anregungen zu konkreten Inhalten und Seiten können Sie sich gerne an Frau Kaulich oder die unter „Kontakt“ benannte eMail wenden.<br/>

      Technische Realisierung:<br/>
      Gesundheitsamt der Stadt Frankfurt am Main<br/>
      Abteilung Digitale Zukunft, IT und strategische Planung<br/>
      Breite Gasse 28 <br/>
      60313 Frankfurt am Main <br/>
      <br/>
      Bei Fragen oder Anmerkungen: <br/>
      ga-lotse.gesundheitsamt@stadt-frankfurt.de <br/>
      Microsites: <br/>
      Microsites sind Informationsangebote, die als eigenständige und in sich abgeschlossene Webseiten anmuten. Microsites sind innerhalb des Onlineauftrittes von frankfurt.de realisiert und auf Basis der gleichen technischen Infrastruktur umgesetzt. <br/>
      <br/>
      Hinweise zum Datenschutz: <br/>
      Informationen zum Datenschutz finden Sie unter 
      <a 
        target="_blank" 
        rel="noreferrer" 
        href='https://frankfurt.de/datenschutz' 
        className="text-primary-plain-Color hover:underline"
        >
        https://frankfurt.de/datenschutz
        </a>
      <br/>
    </p>
  </>    
  )
}